import { render, staticRenderFns } from "./AdminProductTemplatesNewScreen.vue?vue&type=template&id=eb1783c0&scoped=true&"
import script from "./AdminProductTemplatesNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductTemplatesNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1783c0",
  null
  
)

export default component.exports